import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Button } from 'primeng/button';
import { DatePipe } from '@angular/common';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Card } from 'primeng/card';
import { AnnouncementHistoryEntry } from '../../../../../shared/models/announcement-history-entry';
import { AnnouncementEventType } from '../../../../../shared/enums/announcement-event-type.enum';
import { HistoryEventDetailsComponent } from '../../../../../shared/components/history-event-details/history-event-details.component';

@Component({
  selector: 'app-announcement-history-entry-details-dialog',
  imports: [Button, Card, DatePipe, HistoryEventDetailsComponent],
  templateUrl: './announcement-history-entry-details-dialog.html',
  styleUrl: './announcement-history-entry-details-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnouncementHistoryEntryDetailsDialog {
  event = input.required<AnnouncementHistoryEntry>();
  protected readonly dialogRef = inject(DynamicDialogRef);
  protected readonly ANNOUNCEMENT_EVENT_TYPE = AnnouncementEventType;

  protected close(): void {
    this.dialogRef.close();
  }

  protected getRodzajZdarzeniaLabel(value: string): string {
    return this.ANNOUNCEMENT_EVENT_TYPE[
      value as keyof typeof AnnouncementEventType
    ] ?? value;
  }
}
